module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"error_content":{"title":"ページを表示できません","message":"何らかの理由でページを正しく表示できませんでした。\\nもう一度ページを開き直しても正しく表示されない時は時間をおいてから再度お試しください。\\n","alt":"ヘルメットを被っているキャッチくん","button":"一覧のトップへ戻る"}}}')
  delete Component.options._Ctor
}
